import React from "react";

export default function TripIcon24({ color = "#14B8A6" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_107_1233)">
        <path
          d="M19.9999 5.0002L16.9999 2.0002L13.9999 5.0002M16.9999 2.0002V14.0003M13.9999 10.0002L16.9999 7.0002L19.9999 10.0002M16.9999 14.0003H6.9999L1.9999 22.0002H21.9999L16.9999 14.0003ZM7.9999 14.0003V22.0002M8.9999 14.0003L13.9999 22.0002M5.9999 4.0002C5.9999 5.1048 5.1045 6.0002 3.9999 6.0002C2.8953 6.0002 1.9999 5.1048 1.9999 4.0002C1.9999 2.8957 2.8953 2.0002 3.9999 2.0002C5.1045 2.0002 5.9999 2.8957 5.9999 4.0002Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_1233">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
